import { render } from "./HeroiconsOutlineCloud.vue?vue&type=template&id=511c607a"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCloud.vue"]])

export default __exports__